import React from 'react';
import styles from './ConfirmationModal.module.css'; // Reusing ConfirmationModal styles

interface ErrorModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, title = 'Error', message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconWrapper}>!</div>
        <h2 className={styles.title} data-testid="error-modal-title">{title}</h2>
        <p className={styles.message} data-testid="error-modal-message">{message}</p>
        <div className={styles.footer}>
          <button className={`${styles.button} ${styles.confirmButton}`} onClick={onClose} data-testid="error-modal-close">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
